export default __webpack_public_path__ + "static/media/Exclamation_result_01.0d702569.png";